<h1 mat-dialog-title class="notification-title">Reset password</h1>
<div mat-dialog-content style="margin-top: 15px; margin-bottom: -15px">
	<span class="mat-caption">{{ 'login.forgotPassword.confirmationCode' | translate }}</span>
	<mat-form-field appearance="outline" style="width: 100%">
		<input type="text" id="confirmationInput" matInput placeholder="{{ 'login.forgotPassword.confirmationCode' | translate }}" [(ngModel)]="confirmInput" />
	</mat-form-field>
	<span class="mat-caption">{{ 'login.forgotPassword.newPassword' | translate }}</span>
	<mat-form-field appearance="outline" style="width: 100%">
		<input type="text" id="newPasswordInput" matInput placeholder="{{ 'login.forgotPassword.newPassword' | translate }}" [(ngModel)]="newPasswordInput" />
	</mat-form-field>
</div>
<div mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">{{ 'login.forgotPassword.cancelBtn' | translate }}</button>
	<button mat-flat-button color="primary" cdkFocusInitial (click)="onOkClick()" [disabled]="!(confirmInput && newPasswordInput)">{{ 'login.forgotPassword.okBtn' | translate }}</button>
</div>
